import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import useStore from "../../../context/useStore";
import tools from "../../../helpers/tools";
import $ from "jquery";

const FormContinue = (props) => {
  const [state, dispatch] = useStore();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (modalOpen) $("#blur-container").css("filter", "blur(5px)");
    else $("#blur-container").css("filter", "none");
  }, [modalOpen]);

  useEffect(() => {
    try {
      var ans = JSON.parse(localStorage.percevalFormAnswers);
      var st = JSON.parse(localStorage.percevalFormStep);

      setModalOpen(true);
    } catch (err) {}
  }, []);

  const wishToContinue = (isYes) => {
    if (isYes) {
      try {
        var ans = JSON.parse(localStorage.percevalFormAnswers);
        var st = JSON.parse(localStorage.percevalFormStep);

        props.setAnswers(ans);
        props.setStep(st);
      } catch (err) {}
    } else {
      emptyLocalStorage();
    }
    setModalOpen(false);
  };

  const emptyLocalStorage = () => {
    localStorage.removeItem("percevalFormAnswers");
    localStorage.removeItem("percevalFormStep");
    props.setStep(0);
  };

  useEffect(() => {
    if (!state.auth.isAuthenticated && props.answers && props.answers.id) {
      props.setAnswers(tools.buildAnswersObject(props.formConfig.form));
      emptyLocalStorage();
    }
  }, [state.auth.isAuthenticated]);

  useEffect(() => {
    if (props.step > 0) {
      localStorage.setItem(
        "percevalFormAnswers",
        JSON.stringify(props.answers)
      );
      localStorage.setItem("percevalFormStep", JSON.stringify(props.step));
    }
  }, [props.answers, props.step]);

  return (
    <Modal
      title="Bon retour parmis nous !"
      id="continue-modal"
      noActions={true}
      isOpen={modalOpen}
      setIsOpen={setModalOpen}
    >
      <p>
        Souhaitez-vous reprendre ce formulaire à l'étape ou vous étiez jadis ?
      </p>
      <div className="d-flex flex-wrap align-items-center justify-content-center">
        <button
          className="btn btn-primary w-100 mx-1 mx-md-0 py-2 mb-2"
          onClick={() => wishToContinue(true)}
        >
          Oui, reprendre à l'endroit ou je me suis arrêté
        </button>
        <button
          className="btn btn-link w-100 mx-1 mx-md-0 py-2"
          onClick={() => wishToContinue(false)}
        >
          Non, je souhaite reprendre depuis le début
        </button>
      </div>
    </Modal>
  );
};

export default FormContinue;
